import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbx = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_1",
		fill: "#EF3E2B",
		d: "m0,6.24332l0,0.71678l11.96248,6.20177l10.73233,-5.53693l0,2.25425l-10.73233,5.58891l-11.35307,-5.94211l-0.60941,0.30125l0,4.31111l11.96248,6.1914l10.73233,-5.52655l0,2.20225l-10.73233,5.57846l-11.35307,-5.94195l-0.60941,0.31162l0,0.76867l11.96248,6.1914l11.95118,-6.1914l0,-4.30069l-0.553,-0.31165l-11.39818,5.9421l-10.68724,-5.63044l0,-2.2023l10.68724,5.52657l11.95118,-6.2018l0,-4.24879l-0.553,-0.30125l-11.39818,5.94205l-10.13425,-5.27721l10.13425,-5.27722l8.39627,4.35266l0.72234,-0.40513l0,-0.57136l-9.11861,-4.7578l-11.96248,6.24332z"
	}));
});
export default SvgDbx;
